// 获取返回state数据

/*
* 对应在组件里获取state值
*/
// import { mapGetters } from "vuex";
// ...mapGetters([
//   'locale'
// ])

export const locale = state => state.locale
export const connect = state => state.connect



// WEBPACK FOOTER //
// ./examples/store/getters.js